import React, { useEffect, useRef, useState } from "react";
import "./FloatingPhotoComment.css";

export function clampCommentPosition(x, y, width, height, viewportWidth, viewportHeight) {
  return { x: Math.max(8, Math.min(x, viewportWidth - width - 8)), y: Math.max(8, Math.min(y, viewportHeight - height - 8)) };
}

export default function FloatingPhotoComment({ children }) {
  const panel = useRef(null);
  const drag = useRef(null);
  const [position, setPosition] = useState(null);
  const constrain = (x, y) => {
    const rect = panel.current.getBoundingClientRect();
    return clampCommentPosition(x, y, rect.width, rect.height, window.innerWidth, window.innerHeight);
  };
  useEffect(() => {
    const fit = () => setPosition(previous => previous ? constrain(previous.x, previous.y) : previous);
    const observer = new ResizeObserver(fit);
    observer.observe(panel.current);
    window.addEventListener("resize", fit);
    return () => { observer.disconnect(); window.removeEventListener("resize", fit); };
  }, []);
  const stop = event => event.stopPropagation();
  return <section ref={panel} className="floating-photo-comment" style={position ? { left: position.x, top: position.y, bottom: "auto" } : undefined}
    onMouseDown={stop} onMouseMove={stop} onMouseUp={stop} onWheel={stop}
    onPointerDown={event => {
      event.stopPropagation();
      if (event.button !== 0 || !event.target.closest("[data-comment-drag]")) return;
      const rect = panel.current.getBoundingClientRect();
      drag.current = { id: event.pointerId, x: event.clientX - rect.left, y: event.clientY - rect.top };
      event.target.setPointerCapture(event.pointerId);
      event.preventDefault();
      event.target.focus();
    }}
    onPointerMove={event => {
      event.stopPropagation();
      if (drag.current?.id !== event.pointerId) return;
      setPosition(constrain(event.clientX - drag.current.x, event.clientY - drag.current.y));
    }}
    onPointerUp={event => { event.stopPropagation(); drag.current = null; }}
    onPointerCancel={() => { drag.current = null; }}
    onLostPointerCapture={() => { drag.current = null; }}
    onKeyDown={event => {
      if (!event.target.matches("[data-comment-drag]")) return;
      if (event.key === "Home") { event.preventDefault(); setPosition(null); return; }
      const delta = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[event.key];
      if (!delta) return;
      event.preventDefault(); event.stopPropagation();
      const rect = panel.current.getBoundingClientRect();
      const step = event.shiftKey ? 40 : 10;
      setPosition(constrain(rect.left + delta[0] * step, rect.top + delta[1] * step));
    }}>{children}</section>;
}
